import React, { useSyncExternalStore } from "react";
import { hasOverdueAlert, subscribeOverdueAlert } from "../../services/overdueAlert";

export const Box = ({className, title, tools, children}) => {
    // Abre espaço para a faixa de inadimplência. Acompanha o estado atual, que
    // muda a cada resposta da API — não só no login.
    const active = useSyncExternalStore(subscribeOverdueAlert, hasOverdueAlert);

    return (
        <div className={`box ${className ?? ''}  ${active ? 'with-defaulter-tag' : ''}`}>
            {(title || tools) &&
                <div className="header">
                    <span>{title}</span>
                    {tools}
                </div>
            }
            <div className="body">
                {children}
            </div>
        </div>
    );
}

export default Box;
